import XLSX from 'xlsx'
/**
 * 工具类
 * @type {{deepClone: (function(*=): {})}}
 */
let HelperUtil = {
  // 深度克隆
  deepClone: (target) => {
    // 定义一个变量
    let result
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
      // 如果是一个数组的话
      if (Array.isArray(target)) {
        result = [] // 将result赋值为一个数组，并且执行遍历
        for (let i in target) {
          // 递归克隆数组中的每一项
          result.push(HelperUtil.deepClone(target[i]))
        }
        // 判断如果当前的值是null的话；直接赋值为null
      } else if (target === null) {
        result = null
        // 判断如果当前的值是一个RegExp对象的话，直接赋值
      } else if (target.constructor === RegExp) {
        result = target
      } else {
        // 否则是普通对象，直接for in循环，递归赋值对象的所有值
        result = {}
        for (let i in target) {
          result[i] = HelperUtil.deepClone(target[i])
        }
      }
      // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
      result = target
    }
    // 返回最终结果
    return result
  },
  //检测敏感字符
  strCheck: (str) => {
    const result = str.match('[`~!#$%^&*()_\\-+=<>?:\\"{}|,.\\/;\'\\\\[\\] ]')
    return result === null
  },
  checkPassword: (password) => {
    return /^(?=.*\d)(?=.*[a-z])[a-zA-Z0-9]{5,14}$/.test(password)
  },
  cha: (str) => {
    return /.*[\u4e00-\u9fa5]+.*$/.test(str)
  },
  // 检测是否为空
  isEmpty: (checked) => {
    //    var a = " "
    //    var a = null
    //    var a = undefined
    //    var a = []
    //    var a = {}
    //    var a = NaN
    // "",null,undefined
    if (checked === '' || checked === null || checked === undefined) {
      return true
    } else if (typeof checked === 'object') {
      if (typeof checked.length == 'undefined') {
        if (JSON.stringify(checked) === '{}') {
          return true
        }
      } else if (checked.length === 0) {
        return true
      }
    } else if (Object.is(checked, NaN)) {
      // "",null,undefined,NaN
      return true
    }
    return false
  },
  // 获取url的 文件名
  getUrlFilename: (url) => {
    let rep_1 = new RegExp('([^<>/\\\\\\|:""\\*\\?]+)\\.\\w+$')

    return rep_1.exec(url)
  },
  compressCode(str) {
    return str
  },
  readExcel(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        const data = ev.target.result
        // 读取整个文件数据
        const workbook = XLSX.read(data, {
          type: 'binary',
        })
        // 取第一张表
        const wsname = workbook.SheetNames[0]
        // 生成json表格内容
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
        resolve(ws)
      }
      fileReader.onerror = () => {
        reject(Error)
      }
      fileReader.readAsBinaryString(file)
    })
  },
}

export default HelperUtil
